import io from 'socket.io-client';
import { SOCKET_URL } from './api';

let socket = null;

const listeners = {
  message: new Set(),
  typing: new Set(),
  delete: new Set(),
  markRead: new Set()
};

const getSocketUrl = () => {
  return SOCKET_URL;
};

export const chatService = {
  connect: (roomId, userId) => {
    // If socket is already active and connected, reuse it instead of reconnecting
    if (socket && socket.connected) {
      if (userId) socket.emit('join_user', userId);
      if (roomId) socket.emit('join_room', roomId);
      return socket;
    }
    const socketUrl = getSocketUrl();
    const token = localStorage.getItem('kanjusee_token');
    socket = io(socketUrl, {
      transports: ['websocket'],
      autoConnect: true,
      auth: { token }
    });

    socket.on('connect', () => {
      console.log('⚡ Chat Socket.io connected to server:', socket.id);
      if (userId) {
        socket.emit('join_user', userId);
      }
      if (roomId) {
        socket.emit('join_room', roomId);
      }
    });
    socket.on('receive_private_message', (msg) => {
      listeners.message.forEach(cb => cb(msg));
    });

    socket.on('user_typing', (data) => {
      listeners.typing.forEach(cb => cb(data));
    });

    socket.on('message_deleted', (data) => {
      listeners.delete.forEach(cb => cb(data));
    });

    socket.on('messages_marked_read', (data) => {
      listeners.markRead.forEach(cb => cb(data));
    });

    socket.on('disconnect', (reason) => {
      console.log('❌ Chat Socket.io disconnected:', reason);
    });

    return socket;
  },

  disconnect: () => {
    if (socket) {
      socket.disconnect();
      socket = null;
    }
  },

  joinRoom: (roomId) => {
    if (socket) {
      socket.emit('join_room', roomId);
    }
  },

  leaveRoom: (roomId) => {
    if (socket) {
      socket.emit('leave_room', roomId);
    }
  },

  sendMessage: (roomId, senderId, content, mediaUrl = null, mediaType = null) => {
    if (socket) {
      socket.emit('send_private_message', { roomId, senderId, content, mediaUrl, mediaType });
    }
  },

  deleteMessage: (roomId, messageId) => {
    if (socket) {
      socket.emit('delete_message', { roomId, messageId });
    }
  },

  sendTyping: (roomId, senderId, isTyping) => {
    if (socket) {
      socket.emit(isTyping ? 'typing' : 'stop_typing', { roomId, senderId });
    }
  },

  markRead: (roomId, userId) => {
    if (socket) {
      socket.emit('mark_read', { roomId, userId });
    }
  },

  onMessage: (cb) => {
    listeners.message.add(cb);
    return () => listeners.message.delete(cb);
  },

  onTyping: (cb) => {
    listeners.typing.add(cb);
    return () => listeners.typing.delete(cb);
  },

  onDelete: (cb) => {
    listeners.delete.add(cb);
    return () => listeners.delete.delete(cb);
  },

  onMarkRead: (cb) => {
    listeners.markRead.add(cb);
    return () => listeners.markRead.delete(cb);
  }
};
